import { RadioButton } from './radioButton';
import { RadioGroupContainer, RadioGroupItem, RadioGroupItemLabel } from './styles';

interface RadioGroupOption {
  key: string;
  value: string;
  label: string;
  // allows the option to appear as selected if the current value is in the array
  selectedOn?: (string | undefined)[];
  disabled?: boolean;
}

interface RadioGroupProps {
  options: RadioGroupOption[];
  value?: string;
  onChange: (nextValue: string) => void;
  horizontal?: boolean;
  disabled?: boolean;
  className?: string;
}

export const RadioGroup = ({ options, value, onChange, horizontal, disabled, className }: RadioGroupProps) => {
  const getChangeHandler = (option: RadioGroupOption) => () => {
    onChange(option.value);
  };

  return (
    <RadioGroupContainer horizontal={horizontal} className={className}>
      {options.map((option) => (
        <RadioGroupItem key={option.key}>
          <RadioButton
            value={option.selectedOn ? option.selectedOn.includes(value) : option.value === value}
            onChange={getChangeHandler(option)}
            disabled={Boolean(disabled || option.disabled)}
          />
          <RadioGroupItemLabel>{option.label}</RadioGroupItemLabel>
        </RadioGroupItem>
      ))}
    </RadioGroupContainer>
  );
};
